export const CURRENT_ANSWERS_KEY = 'fhs_current_answers_v2';
export const COMPLETED_ANSWERS_KEY = 'fhs_completed_answers_v2';

export const CURRENT_ANSWERS_MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000; // 14 days
export const COMPLETED_ANSWERS_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
